import React, { useCallback } from 'react';
import { inputs } from '@ecosystem/newron-design-system';

import { MultiSelectConfigItem } from '../types';
import { ConfigItemElementProps } from './types';

const { MultiSelect } = inputs;

function MultiSelectElement({
  configItem,
  onChange,
  onRequestOptions,
}: Readonly<ConfigItemElementProps<MultiSelectConfigItem>>) {
  const {
    label,
    key,
    placeholder,
    options,
    value: actualValue,
    combobox,
    showSelectAllOptions,
    tooltipInfo,
    disabled,
    isLoading,
  } = configItem;
  const values = actualValue?.map(({ value }) => value);

  const handleChange = (value: string[]) => {
    const entities = value
      .map(val => options.find(option => option.value === val))
      .map(o => ({ value: o?.value, label: o?.label }));
    onChange(key, entities);
  };

  const handleUnselectAll = useCallback(() => {
    onChange(key, []);
  }, [key, onChange]);

  const handleSelectAll = useCallback(() => {
    const allValues = options.map(o => ({ value: o.value, label: o.label }));
    onChange(key, allValues);
  }, [key, onChange, options]);

  const handleMenuOpen = useCallback(() => {
    onRequestOptions?.(key);
  }, [key, onRequestOptions]);

  return (
    <MultiSelect
      placeholder={placeholder ?? 'Any'}
      label={label}
      options={options}
      values={values}
      disabled={disabled}
      onChange={handleChange}
      onMenuOpen={handleMenuOpen}
      combobox={combobox}
      primaryLinkButtonLabel="Select all"
      isPrimaryLinkButtonEnabled={showSelectAllOptions}
      onPrimaryLinkButtonClick={handleSelectAll}
      secondaryLinkButtonLabel="Unselect all"
      isSecondaryLinkButtonEnabled={showSelectAllOptions}
      onSecondaryLinkButtonClick={handleUnselectAll}
      tooltipInfo={tooltipInfo}
      tooltipPlacement="top"
      isLoading={isLoading}
    />
  );
}

export { MultiSelectElement };
